import { Component, OnInit, ViewChildren, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addallowance',
  templateUrl: './addallowance.component.html',
  styleUrls: ['./addallowance.component.css'],
 
})
export class AddallowanceComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;


  formname: String = "Allowance";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  istds: boolean = false;
  ispf: boolean = false;
  isesi: boolean = false;
  isprofessionaltax: boolean= false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  allowanceColl: any = [];
  allowanceBO: any = {};
  allowanceid: number = 0
  settingsColl: any = [];

  allowanceform = new FormGroup({
    allowanceid: new FormControl(0),
    allowancename: new FormControl('', Validators.required),
    isesi: new FormControl(false),
    ispf: new FormControl(false),
    isprofessionaltax: new FormControl(false),
    istds: new FormControl(false),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.allowanceid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {

    try {
      this.isaddmode = true;
      this.allowanceform.reset();
      this.fnInitializeFormGroup();

      if (this.allowanceid > 0) {
        this.fngetAllowance();
      }
      this.fngetSettings();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.allowanceid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }


  fnInitializeFormGroup() {
    this.allowanceform.setValue({
      allowanceid: 0,
      allowancename: '',
      isesi: false,
      ispf: false,
      isprofessionaltax: false,
      istds: false,
      inactive: false
    })
  }

  fngetSettings() {   
    var data = {
        'settingsid':0,
        'companyid': this.loginService.fnGetCompanyId(),                                                                       
    }
    this.appService.getSettings(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
            this.settingsColl=res.json().result[1];  
           for(let row of this.settingsColl){
            
            
              if(row.settingsname === 'ENABLE ESI' && row.settingsvalue ==='1'){
                
                this.isesi=true;
              
              }
              if(row.settingsname === 'ENABLE TDS' && row.settingsvalue ==='1'){
                
                this.istds=true;
              
              }
              if(row.settingsname === 'ENABLE PF' && row.settingsvalue ==='1'){
                
                this.ispf=true;
              
              }
              if(row.settingsname === 'ENABLE PROFESSIONAL TAX' && row.settingsvalue ==='1'){
                
                this.isprofessionaltax=true;
              
              }
           }
                         }                 
         else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }


  //Get 
  fngetAllowance() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();

    var data = {
      'allowanceid': this.allowanceid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAllowance(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.allowanceColl = res.json().result;
            var editdata = this.allowanceColl[0];
            this.fnEditMode(editdata);
            this.allowanceBO = editdata;

          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.allowanceform.valid) {
        //Check
        var data = {
          'allowanceid': this.allowanceid,
          'allowancename': this.allowanceform.get('allowancename').value,
          'isesi': this.allowanceform.get('isesi').value,
          'ispf': this.allowanceform.get('ispf').value,
          'isprofessionaltax': this.allowanceform.get('isprofessionaltax').value,
          'istds': this.allowanceform.get('istds').value,
          'inactive': this.allowanceform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckAllowance(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.allowanceform.get('allowanceid').value > 0) {
                  //Update 
                  this.fnSetAllowance(data);
                }
                else {
                  //Insert 
                  this.fnInsertAllowance(data);
                }
              }
              else {

                if (_checkresult === "name") {
                  this.allowanceform.controls['allowancename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAllowance(data) {

    this.appService.fnInsertAllowance(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new Allowance has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.allowancename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAllowance(data) {

    this.appService.fnSetAllowance(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The Allowance has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.allowanceid, data.allowancename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/Allowance']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.allowanceform.setValue({
      allowanceid: deptBO.allowanceid,
      allowancename: deptBO.allowancename,
      isesi: deptBO.isesi,
      ispf: deptBO.ispf,
      isprofessionaltax: deptBO.isprofessionaltax,
      istds:deptBO.istds,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }



      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
